import classNames from 'classnames/bind';
import style from './Footer.module.scss';
import { useMode } from '../../helpers/hooks/useQueryParams';
import Lock from '../Icons/Lock';

const cx = classNames.bind(style);

const Footer = () => {
  const mode = useMode();
  return (
    <div className={cx('login-footer')} data-testid="login-footer">
      {mode === 'checkout' && (
        <p
          className={cx('secure-checkout-wrapper')}
          style={{ marginBottom: 30 }}
        >
          <Lock /> Secure Checkout
        </p>
      )}
    </div>
  );
};

export default Footer;
